<template>
  <!-- READ ONLY MODE -->

  <div v-if="mode == 'VIEW'">
    <div class="instruction_info fs-18 ql-editor p-0" v-html="question.formattedBody"></div>
    <div class="col-md-12 col-sm-12 col-12 p-0 pt-15 table-overflow" v-if="question.content != '[]' && question.content[0] != undefined && question.content[0]['options'] != undefined">
      <!--Start of Static Table Structure -->
      <div class="medication_selector_table_container">
        <div class="row table_heading">
          <div v-bind:class="[question.content[0]['options'][0]['dosageUnits'] ? 'col-md-3' : 'col-md-4']" class="text-center border padding">
            Category
          </div>
          <div v-bind:class="[question.content[0]['options'][0]['dosageUnits'] ? 'col-md-3' : 'col-md-4']" class="col-md-3 text-center border padding">
            Medication
          </div>
          <div v-bind:class="[question.content[0]['options'][0]['dosageUnits'] ? 'col-md-3' : 'col-md-4']" class="col-md-3 text-center border padding">
            Dosage
          </div>
          <div v-if="question.content[0]['options'][0]['dosageUnits']" class="col-md-3 text-center border padding">
            Dosage Unit
          </div>
        </div>
        <table class="medication_selector_table1">
          <colgroup>
            <col style="15%" />
          </colgroup>
          <colgroup>
            <col style="65%" />
          </colgroup>
          <colgroup>
            <col style="10%" />
          </colgroup>
          <colgroup>
            <col style="10%" />
          </colgroup>
          <tbody>
            <span v-for="(option, key) in question.content[0]['options']" :key="key">
              <tr v-for="(dosage, index) in option['dosage']" :key="index">
                <td v-if="index == 0">
                  <span class="cat_name_col1">{{ option["category"] }}</span>
                </td>
                <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                <td v-if="index == 0">
                  <span class="med_name_col2">{{ option["name"] }}</span>
                </td>
                <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                <td>{{ dosage }}</td>
                <td v-if="option['dosageUnits']">
                  {{ option["dosageUnits"][index] }}
                </td>
              </tr>
            </span>
          </tbody>
        </table>
      </div>
      <!--End of Static Table Structure-->
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="p-0">
      <div v-if="!restrictAddHelp" @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :class="{
            'right-position': activityDetails.customParticipantMessaging
          }"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="bg-white mt-30" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled && !restrictAddHelp">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-40 mb-10" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 pl-0 pt-15">
        <h5 class="mb-15">
          List Content
          <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleInfoDiv()" @blur="hidePopup()" tabindex="-1"></span>
          <div class="info-circle-div" v-show="infoDiv">
            To upload list content, you must first download the CSV template provided below. When filling out, follow the examples provided in the template, but be sure to remove the examples prior to upload. Do not add or change the columns within the template. However, you may change the title of the template when saving as long as it remains as a CSV file. The Category and Medication columns
            will automatically display in alphabetical order within the participant app. The Dosage column will display in the order as it is listed within the template. For any corrections, you must first delete the existing template and then upload the corrected one.
          </div>
        </h5>
        <input ref="uploadMedication" style="display:none;" type="file" accept=".csv" class="file-input list-content" id="file_upload" @change="onFileChange($event)" />
        <button class="dummy-list-content mb-5 text-left" v-if="question.content != '[]' && question.content != undefined && question.content[0] != undefined && question.content[0].fileName != undefined">
          <span v-if="question.content[0].fileName.length > 18" class="fs-14 ml-0 csv-file-name" v-b-tooltip.hover :title="question.content[0].fileName">{{ question.content[0].fileName }}</span>
          <span v-else class="fs-14 ml-0 csv-file-name">{{ question.content[0].fileName }}</span>
          <button class="btn p-0 csv_file_delete btn-link color_red float-right" @click="deleteFileField()">
            <img class="p-0" src="static/img/delete.svg" />
          </button>
        </button>
        <button class="dummy-list-content mb-5" @click="uploadList()" v-else>
          Upload List
        </button>
        <a download href="../static/csv-template/Medication Selector template.csv" class="text-primary fs-12 fw-bold">Download CSV template</a>
      </div>
      <div class="col-md-1 p-0 pt-20">
        <div class="row">
          <div class="col-md-2">
            <h5 class="score_text">Score</h5>
            <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model="question.score">
              <input v-model.number="question.score" type="number" class="integer-plus-minus-input pl-4" min="0" max="999" @input="validateScore" />
            </integer-plusminus>
          </div>
        </div>
      </div>

      <div class="col-md-3 pl-50">
        <div class="pt-55 fs-15">
          <label>
            <input type="checkbox" v-model="question.isAllowOtherDosage" @change="verifyDosage" />
            <span class="text-align">Allow 'Other' dosage</span>
          </label>
        </div>
      </div>

      <div class="col-md-6 col-sm-6 col-6 p-0 pt-20" v-if="question.content != undefined && question.content != '[]' && question.content[0] != undefined && question.content[0]['options'] != undefined">
        <!--Start of Static Table Structure -->
        <div class="medication_selector_table_container">
          <div class="row table_heading">
            <div v-bind:class="[question.content[0]['options'][0]['dosageUnits'] ? 'col-md-3' : 'col-md-4']" class="text-center border padding">
              Category
            </div>
            <div v-bind:class="[question.content[0]['options'][0]['dosageUnits'] ? 'col-md-3' : 'col-md-4']" class="col-md-3 text-center border padding">
              Medication
            </div>
            <div v-bind:class="[question.content[0]['options'][0]['dosageUnits'] ? 'col-md-3' : 'col-md-4']" class="col-md-3 text-center border padding">
              Dosage
            </div>
            <div v-if="question.content[0]['options'][0]['dosageUnits']" class="col-md-3 text-center border padding">
              Dosage Unit
            </div>
          </div>
          <table class="medication_selector_table1">
            <colgroup>
              <col style="15%" />
            </colgroup>
            <colgroup>
              <col style="65%" />
            </colgroup>
            <colgroup>
              <col style="10%" />
            </colgroup>
            <colgroup>
              <col style="10%" />
            </colgroup>
            <tbody>
              <span v-for="(option, key) in question.content[0]['options']" :key="key">
                <tr v-for="(dosage, index) in option['dosage']" :key="index">
                  <td v-if="index == 0">
                    <span class="cat_name_col1">{{ option["category"] }}</span>
                  </td>
                  <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                  <td v-if="index == 0">
                    <span class="med_name_col2">{{ option["name"] }}</span>
                  </td>
                  <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                  <td>{{ dosage }}</td>
                  <td v-if="option['dosageUnits']">
                    {{ option["dosageUnits"][index] }}
                  </td>
                </tr>
              </span>
            </tbody>
          </table>
        </div>
        <!--End of Static Table Structure-->
      </div>
      <div class="clearfix"></div>
    </div>
    <br />
    <div v-if="question.isAllowOtherDosage" class="row">
      <h5 class="mb-15" v-if="dosageTypeFilter.length >= 1">Dosage Unit</h5>
      <h5 class="mb-15" v-else>Available Dosage Unit</h5>
      <div class="col-lg-3 col-md-6 pl-0 pr-10">
        <ActivityLibrarySelect :options="dosageOptions" v-model="dosageTypeFilter" field="value" title="Select dosage units" @clearFilterValue="clearDosageFilter" :add_button="true" :button_text="'Add New Unit'" :select_all_button="true" :select_button_text="'SELECT ALL'" />
      </div>
      <div class="col-md-6">
        <div class="medication_selctor_modal">
          <b-modal id="modal-prevent-closing" ref="modal" :hide-footer="true" size="lg" @hidden="hide">
            <div class="text-center">
              <label>
                <b>Enter new dosage unit </b>
              </label>
            </div>
            <div class="clearfix"></div>

            <form ref="form" @submit.stop.prevent="handleSubmit">
              <b-form-group class="mb-50" label-for="name-input" invalid-feedback="Name is required">
                <b-form-input id="name-input" placeholder="Name" v-model="dosageUnitName" required></b-form-input>
              </b-form-group>
            </form>
            <div class="clearfix"></div>
            <template #modal-footer>
              <div class="d-flex justify-content-between mb-20">
                <button v-b-modal.modal-close_visit class="modal-btn btn btn-secondary btn-sm m-1 pl-20 pr-20" @click="hideModal">
                  Cancel
                </button>
                &nbsp;&nbsp;
                <button v-b-modal.modal-close_visit class="modal-btn btn btn-primary btn-sm m-1 pl-20 pr-20" @click="handleOk">
                  Add
                </button>
              </div>
            </template>
          </b-modal>
        </div>
      </div>
    </div>
    <br />
    <div class="row" v-if="question.canCollectReason">
      <h5 class="mb-15">Available Reasons</h5>
      <div class="show-dropdown" v-for="(item, index) in reasons" :key="index">
        <input type="text" placeholder="Enter reason" class="col-sm-8 mr-15 form-control form-control-sm input-style limit_select_input mt-5 pb-3 pt-3" v-model="item.value" @input="addReason(item.value, index)" />
        <div class="col-sm-1 pl-0 delete_button color_red">
          <img class="btn btn-link pt-5 pl-0 mt-5 mr-5 p-0" @click="removeReason(index)" v-if="question.canCollectReason && reasons.length > 1" src="static/img/delete.svg" />
        </div>
        <div class="col-sm-3"></div>
      </div>
    </div>
    <div class="row" v-if="question.canCollectReason">
      <div class="col-sm-3 pl-0 pt-10">
        <span @click="addAnotherReason()" class="add_another_data_check">Add another reason</span>
      </div>
      <div class="col-sm-9"></div>
    </div>
    <div class="row" v-if="question.canCollectReason">
      <div class="pl-0 pt-10">
        <label class>
          <input type="checkbox" class="toggle-checkbox" v-model="question.addOtherReason" />
          <span class="position_relative">Add an "Other" reason option for comment field </span>
        </label>
      </div>
      <div class="col-sm-9"></div>
    </div>
  </div>
</template>
<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import Papa from "papaparse";
import filter from "lodash/filter";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import ActivityLibrarySelect from "../activity-library-select";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepMedicationSelector",
  mixins: [activityStepCustomMessage],
  props: {
    question: {},
    mode: {
      default: "VIEW"
    },
    commonProps: {},
    activityDetails: {},
    editorOptionForHelp: {
      type: Object
    },
    restrictAddHelp: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IntegerPlusminus,
    ActivityLibrarySelect,
    quillEditor
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    },
    dosageTypeFilter() {
      this.question.dosageUnits = [];
      this.dosageTypeFilter.forEach((option, ind) => {
        this.question.dosageUnits[ind] = option.value;
      });
    },
    "question.canCollectReason": {
      handler() {
        if (!this.question.canCollectReason) {
          this.question.reasons = [];
          this.reasons = [{ value: "" }];
        }
      }
    },
    "question.isAllowOtherDosage": {
      handler() {
        if (!this.question.isAllowOtherDosage) {
          this.clearDosageFilter();
        }
      }
    }
  },
  data() {
    return {
      editorOptionForQuestion: {
        placeholder: "Select the pain medication you are taking from the list below.",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      isAddHelpEnabled: false,
      infoDiv: false,
      reasons: [],
      dosageOptions: [
        { value: "breaths", id: 1 },
        { value: "g", id: 2 },
        { value: "IU", id: 3 },
        { value: "mcg", id: 4 },
        { value: "mcg/hr", id: 5 },
        { value: "mcg/ml", id: 6 },
        { value: "mEq", id: 7 },
        { value: "mg", id: 8 },
        { value: "mg/cm2", id: 9 },
        { value: "mg/g", id: 10 },
        { value: "mg/ml", id: 11 },
        { value: "mL", id: 12 },
        { value: "tbp", id: 13 },
        { value: "tbsp", id: 14 },
        { value: "%", id: 15 }
      ],
      isDisplayOptions: false,
      dosageTypeFilter: [],
      dosageUnitName: ""
    };
  },
  mounted() {
    if (!this.restrictAddHelp) {
      this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    }
    this.init();
    this.setReasonDosage();
  },
  methods: {
    hide() {
      this.dosageUnitName = "";
    },
    hideModal() {
      this.$refs.modal.hide();
      this.dosageUnitName = "";
    },
    addReason(reason, index) {
      this.question.reasons[index] = reason;
    },
    isChecked(id) {
      return this.value.findIndex(e => e.id === id) > -1;
    },
    openDropdown() {
      if (!this.isDisplayOptions) {
        this.isDisplayOptions = true;
      } else {
        this.isDisplayOptions = false;
      }
    },
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    validateScore(e) {
      if (this.question.score < 0 || this.question.score > 999) {
        this.question.score = Math.abs(e.target.value.slice(0, 3));
        return;
      }
      if (this.question.score == "") {
        this.question.score = 0;
      }
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "score", 0);
        this.$set(this.question, "content", []);
        this.$set(this.question, "isAllowOtherDosage", true);
      } else {
        this.$set(this.question, "score", this.question.score);
      }
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const dosageTypes = this.dosageTypeFilter;
      const errorObj = { isValid: true };

      if (!question.formattedBody || question.formattedBody.trim() === "") {
        errorObj.msg = "Step Title is required.";
        errorObj.isValid = false;
        return errorObj;
      }
      if (question.isAddHelpEnabled && !this.restrictAddHelp && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      if (question.canCollectReason) {
        this.reasons.forEach(option => {
          if (option.value == "") {
            errorObj.msg = "Please enter reason to continue.";
            errorObj.isValid = false;
            return errorObj;
          }
        });
      }

      const reasonExists = [];
      for (let i = 0; i < this.reasons.length; i++) {
        if (reasonExists.indexOf(this.reasons[i].value) !== -1) {
          errorObj.msg = "Reason(s) must be unique.";
          errorObj.isValid = false;
          return errorObj;
        }
        reasonExists.push(this.reasons[i].value);
      }

      if (!dosageTypes.length && question.isAllowOtherDosage) {
        errorObj.msg = "Please select Dosage Unit(s).";
        errorObj.isValid = false;
        return errorObj;
      }
      return errorObj;
    },
    uploadList() {
      const elem = this.$refs.uploadMedication;
      elem.click();
    },
    deleteFileField() {
      this.question.content = [];
      this.$refs.uploadMedication.value = null;
    },
    hidePopup() {
      this.infoDiv = false;
      this.$el.blur();
    },
    showPopup() {
      this.infoDiv = true;
      this.$el.focus();
    },
    toggleInfoDiv() {
      if (this.infoDiv) {
        this.hidePopup();
      } else {
        this.showPopup();
      }
    },
    validateCsvFile(file) {
      const isValid = file.name.match(/.(csv)$/i);
      return isValid;
    },
    onFileChange(e) {
      const fd = new FormData();
      const input = e.target;
      if (!this.validateCsvFile(input.files[0])) {
        this.$refs.uploadMedication.value = null;
        this.$toastr.error("Uploaded file is not in the expected format. Please use the .csv template provided.");
        return;
      }
      fd.append("file", input.files[0]);
      this.setImportValue = fd;
      this.uploadFileName = input.files[0].name;

      Papa.parse(input.files[0], {
        complete: results => {
          const hasMoreThanFourCols = filter(results.data, o => o.length > 4).length;
          const data = filter(results.data, o => o.length >= 4);
          this.fileLength = data.length - 1;

          if (data[0] == undefined) {
            this.$refs.uploadMedication.value = null;
            this.$toastr.error("Uploaded file is not in the expected format. Please use the .csv template provided.");
          } else if (data[0][0] != "Category" || data[0][1] != "Medication" || data[0][2] != "Dosage" || data[0][3] != "Dosage unit") {
            this.$refs.uploadMedication.value = null;
            this.$toastr.error("Column headings in uploaded file are not in the expected format. Please use the .csv template provided.");
          } else if (hasMoreThanFourCols > 0) {
            this.$refs.uploadMedication.value = null;
            this.$toastr.error("Uploaded file contains more than four columns. Please use the .csv template provided.");
          } else if (data.length - 1 > 0 && data[0][0] === "Category" && data[0][1] === "Medication" && data[0][2] === "Dosage" && data[0][3] === "Dosage unit") {
            let isValidFile = true;
            let i;
            for (i = 0; i < data.length; i++) {
              if (data[i].indexOf("") != -1) {
                if (data[i].indexOf("") == 2 || data[i].lastIndexOf("") == 2) {
                  if (!this.question.isAllowOtherDosage) {
                    isValidFile = false;
                    this.$refs.uploadMedication.value = null;
                    this.$toastr.error("Uploaded file is missing value(s) for Dosage and is required when Allow 'Other' dosage configuration is turned off.");
                    break;
                  }
                }
                if (data[i].indexOf("") == 3 || data[i].lastIndexOf("") == 3) {
                  if (!this.question.isAllowOtherDosage) {
                    isValidFile = false;
                    this.$refs.uploadMedication.value = null;
                    this.$toastr.error("Uploaded file is missing value(s) for Dosage unit and is required when Allow 'Other' dosage configuration is turned off.");
                    break;
                  }
                }
                if (data[i].indexOf("") < 2) {
                  isValidFile = false;
                  this.$refs.uploadMedication.value = null;
                  this.$toastr.error("Uploaded file is missing value(s) for Category or Medication. Correct your file and upload again.");
                  break;
                }
              }
            }

            if (isValidFile) {
              if (this.question.id) {
              }

              data.shift();
              const _ = require("lodash");
              this.question.content = [];
              const arr_final = {};
              arr_final["fileName"] = this.uploadFileName;
              const optionsArray = [];

              data.map(item => {
                optionsArray.push({
                  category: item[0],
                  name: item[1]
                });
              });

              const dosages = data.map(item => item[2]);
              const dosagesUnits = data.map(item => item[3]);
              const nameCount = _.countBy(optionsArray, "name");
              const arrOptions = [];
              const allLength = [];

              for (let x in nameCount) {
                allLength.push(nameCount[x]);
                const ind = optionsArray.findIndex(item => item.name == x);
                if (ind != -1) {
                  arrOptions.push(optionsArray[ind]);
                }
              }

              //making Dosage into Chunks as per lengths
              const chunksDosages = dosages;

              let sizes = allLength;

              let i = 0;

              let j = 0;

              const dosChunks = [];
              while (i < chunksDosages.length) {
                dosChunks.push(chunksDosages.slice(i, (i += sizes[j++ % sizes.length])));
              }

              for (let i = 0; i < dosChunks.length; i++) {
                arrOptions[i].dosage = dosChunks[i];
              }

              //making Dosage units into Chunks as per lengths
              const chunksDosagesUnits = dosagesUnits;

              sizes = allLength;

              i = 0;

              j = 0;

              const dosUnitChunks = [];
              while (i < chunksDosagesUnits.length) {
                dosUnitChunks.push(chunksDosagesUnits.slice(i, (i += sizes[j++ % sizes.length])));
              }

              for (let i = 0; i < dosUnitChunks.length; i++) {
                arrOptions[i].dosageUnits = dosUnitChunks[i];
              }

              arr_final["options"] = arrOptions;
              this.question.content.push(arr_final);
              this.$toastr.success("File uploaded successfully.");
            }
          } else {
            this.$refs.uploadMedication.value = null;
            this.$toastr.error("Uploaded file is not in the expected format. Please use the .csv template provided.");
          }
        }
      });
    },
    verifyDosage() {
      if (!this.question.content.length || this.question.isAllowOtherDosage) {
        return;
      }

      const content = this.question.content[0];
      let hasBlankDosage = 0;
      content.options.every(option => {
        hasBlankDosage = option.dosage.filter(dose => {
          return dose === "";
        }).length;

        if (hasBlankDosage > 0) {
          this.$toastr.error("Uploaded file is missing value(s) for Dosage and is required when Allow 'Other' dosage configuration is turned off.");
          this.question.isAllowOtherDosage = !this.question.isAllowOtherDosage;
          return false;
        }
        return true;
      });
    },
    addAnotherReason() {
      if (this.reasons.length <= 9) {
        this.reasons.push({ value: "" });
      } else {
        this.$toastr.error("Number of reasons can not exceed more than 10.");
        return false;
      }
    },
    removeReason(index) {
      this.$delete(this.reasons, index);
      this.$delete(this.question.reasons, index);
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    resetModal() {
      this.dosageUnitName = "";
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Check if value already exists
      if (this.dosageUnitName.trim() == "") {
        this.$toastr.error(`Please enter dosage name.`);
        return;
      }
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }

      // Check if value already exists
      if (this.dosageOptions.some(dose => dose.value === this.dosageUnitName.trim())) {
        this.$toastr.error(`Dosage Unit must be unique.`);
        return;
      }

      // Push the name to submitted names
      this.dosageOptions.push({
        id: this.dosageOptions.length + 1,
        value: this.dosageUnitName
      });
      this.dosageUnitName = "";
      // Hide the modal manually
      this.$nextTick(() => {
        // this.$bvModal.hide('modal-prevent-closing')
        this.$refs["modal"].hide();
      });
    },
    setReasonDosage() {
      if (this.mode == "EDIT") {
        const currentActivity = this.activityDetails.questions.filter(obj => {
          return obj.id === this.question.id;
        });
        if (currentActivity.length && currentActivity[0].reasons && currentActivity[0].reasons.length) {
          currentActivity[0].reasons.forEach(reason => {
            this.reasons.push({ value: reason });
            this.question.reasons.push(reason);
          });
        } else {
          this.reasons = [{ value: "" }];
        }

        if (currentActivity.length && currentActivity[0].dosageUnits && currentActivity[0].dosageUnits.length) {
          currentActivity[0].dosageUnits.forEach(unit => {
            if (!this.dosageOptions.some(dose => dose.value === unit)) {
              const defualtDoseCount = this.dosageOptions.length;
              this.dosageOptions.push({
                value: unit,
                id: defualtDoseCount + 1
              });
            }

            const optionIndex = this.dosageOptions.findIndex(element => element.value === unit);

            this.dosageTypeFilter.push({ value: unit, id: optionIndex + 1 });
          });
        }
      }
    },
    clearDosageFilter() {
      this.dosageTypeFilter = [];
      this.question.dosageUnits = this.dosageTypeFilter;
    }
  }
};
</script>
<style>
button,
input {
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 4px; /* width of the entire scrollbar */
}
::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
::-webkit-scrollbar-thumb {
  background-color: #c4c4c4; /* color of the scroll thumb */
  border-radius: 4px; /* roundness of the scroll thumb */
  height: 50px;
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
::-webkit-scrollbar {
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}
.medication_selector_table_container {
  min-height: 150px;
  width: 385px;
  border: 1px solid #d3dfe4;
  border-radius: 6px 6px 0 0;
  background: rgba(245, 245, 245, 0.3);
  /* margin:24px 0 0 56px;     */
}
.medication_selector_table1 {
  font-size: 12px;
  color: #666669;
  border-color: #ddd;
  width: 100%;
  border: none;
  margin: 5px 5px 0;
  table-layout: fixed;
}
.medication_selector_table1 td {
  border: 1px solid #dee2e6;
  background: #fff;
  font-size: 12px;
  color: #666669;
  width: 124px;
  padding: 0.5rem 0.75rem !important;
  text-align: center;
}
.medication_selector_table1 tbody {
  max-height: 151px;
  width: 373px;
  display: block;
  overflow: auto;
}

.table_heading {
  width: 383.7px;
  background: #d3dfe4;
  border-radius: 6px 6px 0 0;
  font-size: 12px;
  color: #ffffff;
  margin-left: -0.5px !important;
}
.padding {
  padding: 3px 0 1px;
}
/*End of styles for static medication selector table*/

.medication_selector_table {
  font-size: 12px;
  border-color: #ddd;
  min-height: 150px;
  width: 385px;
  border: none;
  margin: 0.5625rem 0rem 0rem 3.625rem;
}
.medication_selector_table tbody {
  max-height: 151px;
  overflow: scroll;
  margin: 10px;
}
.medication_selector_table td {
  border: 1px solid #dee2e6;
  background: #fff;
  padding: 0.544rem 0.75rem;
  text-align: center;
}
.bordered {
  border: 1px solid #cccccc;
  border-radius: 6px 6px 6px 6px;
  -moz-border-radius: 6px 6px 6px 6px;
  -webkit-border-radius: 6px 6px 6px 6px;
}
.medication_selector_table th:first-child {
  border-radius: 6px 0 0 0;
  -moz-border-radius: 6px 0 0 0;
  -webkit-border-radius: 6px 0 0 0;
  background-color: #d3dfe4;
  color: #ffffff;
  text-align: center;
  padding: 0.165rem 0.75rem;
}
.medication_selector_table th:last-child {
  border-radius: 0 6px 0 0;
  -moz-border-radius: 0 6px 0 0;
  -webkit-border-radius: 0 6px 0 0;
  background-color: #d3dfe4;
  color: #ffffff;
  text-align: center;
  padding: 0.165rem 0.75rem;
}
</style>
<style scoped lang="scss">
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
}
.dummy-list-content {
  width: 100%;
  height: 40px;
  padding: 9px 6px 7px;
  border-radius: 3px;
  border: solid 2px #c5d1d6;
  background: white;
  color: #4c8ce4;

  .csv-file-name {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    width: calc(100% - 30px);
    overflow: hidden;
    height: 24px;
    word-break: break-all;
  }
}
th,
td {
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 1px;
  padding-bottom: 1px;
}
.csv_file_delete {
  position: absolute;
  right: 21px;
  bottom: 31.5px;
}
.add-help-text {
  right: 493.5px;
  top: -38px;
  &.right-position {
    right: 598px;
  }
}
.activity-configurator-step-edit-mode .info-circle-div {
  width: 600px;
  height: 150px;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #666669;
  padding: 13px;
  position: absolute;
  border-radius: 3px;
  margin-left: 100px;
  margin-top: 0px;
  -webkit-box-shadow: 1px 1px #d3deef;
  box-shadow: 1px 1px #d3deef;
  z-index: 100;
}
.med_name_col2 {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.cat_name_col1 {
  white-space: nowrap;
  width: 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
</style>
